import type { AuthUser } from '@/api/auth';
import { userSections } from '@/lib/studentFields';

/**
 * Видит ли ученик сторис — ЕДИНСТВЕННОЕ правило фронта (договор `docs/CONTRACTS/stories.md` §1, 13.10.2026).
 *
 * ⚠️ ТОЛЬКО ЯВНЫЙ КЛЮЧ `stories` В `sections`, ОДИНАКОВО НА САЙТЕ И В ПРИЛОЖЕНИИ. Ключ кладёт auth-service только
 * платнику с живой записью на платный курс. Бесплатник (и ревьюер Apple, который входит бесплатником) ключа не
 * получает — и тогда у него нет ни запроса к ручкам сторис, ни ленивого куска с кружками и плеером, ни строки
 * переводов сторис: всё это грузится только за этим условием (`pages/student/StoryBarSlot.tsx`).
 *
 * Сознательно НЕ через `computeHasFeature`: там пустой набор на сайте значит «показать всё», а `*` — «все
 * возможности тарифа». Ключ `stories` не тарифный (его нет в `shared/features`), и «безопасно к блокировке» здесь
 * означало бы запросы бесплатника. Набор ещё не пришёл — сторис нет, ждём `/auth/me`.
 *
 * Сотрудник ленту не смотрит: у него авторские экраны (`/curator/stories`, `/admin/stories`).
 *
 * Сторож — `app/storiesFreeGate.test.ts`.
 */
export function canSeeStories(user: Pick<AuthUser, 'role' | 'sections' | 'features'> | null | undefined): boolean {
  if (!user || user.role !== 'student') return false;
  const sections = userSections(user);
  return Array.isArray(sections) && sections.includes('stories');
}
